const escapeRegex = (s: string): string => {
  return s.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
};

export default escapeRegex;
